<div class="flex-fill d-flex flex-column justify-content-center">
  <div class="container-tight py-6">
    <div class="text-center mb-4">
      <img src="assets/img/logo.png" height="64" alt="">
    </div>
    <div class="card">
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Kullanıcı Adı</label>
          <div class="input-group input-group-flat">
            <input type="text" class="form-control pl-1" [(ngModel)]="kullaniciAdi" (keyup.enter)="login()">
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Şifre</label>
          <div class="input-group input-group-flat">
            <input type="password" class="form-control pl-1" [(ngModel)]="sifre" (keyup.enter)="login()">
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <div class="btn btn-primary" (click)="login()">Giriş Yap</div>
      </div>
    </div>
    <!-- <div class="col-12 text-center">
      <b>Hızlı Giriş (TEST)</b><br>
      <span class="text-blue clickable" *ngFor="let user of testUsers" (click)="loginTestUser(user)">{{user}}<br></span>
    </div> -->
  </div>
</div>
